/* ===== LP Magnifiques produit : routine à composer, onglets matin/soir, ingrédients rayés ===== */
(function () {
  if (window.__mgpCharge) return;
  window.__mgpCharge = true;

  var fmt = null;
  function prix(c) {
    try {
      if (!fmt) {
        var dev = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
        fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: dev });
      }
      return fmt.format(c / 100);
    } catch (e) {
      return (c / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function initConfig(root) {
    if (!root || root.dataset.mgpInit) return;
    root.dataset.mgpInit = '1';
    var cases = [].slice.call(root.querySelectorAll('.mgp-soin input[type="checkbox"]'));
    var total = root.querySelector('[data-mgp-total]');
    var barre = root.querySelector('[data-mgp-barre]');
    var remise = root.querySelector('[data-mgp-remise]');
    var incite = root.querySelector('[data-mgp-incite]');
    var compte = root.querySelector('[data-mgp-compte]');
    var btn = root.querySelector('[data-mgp-ajouter]');
    var statut = root.querySelector('[data-mgp-statut]');
    var completId = parseInt(root.dataset.completId, 10) || 0;
    var completPrix = parseInt(root.dataset.completPrix, 10) || 0;
    var dispo = cases.filter(function (c) { return !c.disabled; }).length;
    var occupe = false;
    var complet = false;

    function maj() {
      var somme = 0, n = 0;
      cases.forEach(function (c) {
        var li = c.closest('.mgp-soin');
        if (li) li.classList.toggle('is-off', !c.checked);
        if (c.checked && !c.disabled) { somme += parseInt(c.dataset.prix, 10) || 0; n++; }
      });
      complet = !!completId && n > 0 && n === dispo;
      if (total) total.textContent = prix(complet ? completPrix : somme);
      if (barre) { barre.textContent = prix(somme); barre.hidden = !complet; }
      if (remise) remise.hidden = !complet;
      if (incite) incite.hidden = complet || n === 0 || !completId;
      if (compte) compte.textContent = n === 0 ? 'Aucun soin sélectionné' : n + (n > 1 ? ' soins sélectionnés' : ' soin sélectionné');
      if (btn && !occupe) {
        btn.disabled = n === 0;
        btn.textContent = n === 0 ? btn.dataset.vide : (complet ? btn.dataset.complet : btn.dataset.selection);
      }
    }
    cases.forEach(function (c) { c.addEventListener('change', maj); });
    maj();

    if (!btn) return;
    btn.addEventListener('click', function () {
      var items = complet ? [{ id: completId, quantity: 1 }] : cases
        .filter(function (c) { return c.checked && !c.disabled; })
        .map(function (c) { return { id: parseInt(c.value, 10), quantity: 1 }; });
      if (!items.length || occupe) return;
      occupe = true;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      if (statut) statut.textContent = '';
      var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(racine + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function () {
          if (statut) statut.textContent = btn.dataset.ok || '';
          if (root.dataset.apres === 'tiroir') {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            var tiroir = document.querySelector('cart-drawer');
            if (tiroir && typeof tiroir.show === 'function') { tiroir.show(); return; }
          }
          window.location.href = racine + 'cart';
        })
        .catch(function () { if (statut) statut.textContent = btn.dataset.erreur || ''; })
        .then(function () { occupe = false; btn.removeAttribute('aria-busy'); maj(); });
    });
  }

  function initOnglets(root) {
    if (!root || root.dataset.mgpInit) return;
    root.dataset.mgpInit = '1';
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    function activer(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activer(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var c = null;
        if (e.key === 'ArrowRight') c = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') c = tabs[(i - 1 + tabs.length) % tabs.length];
        if (c) { e.preventDefault(); activer(c, true); }
      });
    });
    root._mgpActiver = function (el) {
      var p = el.closest('[role="tabpanel"]');
      if (!p) return;
      var t = tabs.filter(function (x) { return x.getAttribute('aria-controls') === p.id; })[0];
      if (t) activer(t, false);
    };
  }

  function initRayes() {
    var els = [].slice.call(document.querySelectorAll('[data-mgp-raye]:not(.is-vu)'));
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-vu'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-vu'); io.unobserve(e.target); }
      });
    }, { threshold: 0.25 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initAll(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-mgp-config]').forEach(initConfig);
    s.querySelectorAll('[data-mgp-onglets]').forEach(initOnglets);
    initRayes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-mgp-onglets]');
    if (root && root._mgpActiver) root._mgpActiver(e.target);
  });
})();
